/**
 * Copy for "Require goods receipt before reorder" (Your Suppliers + checkout).
 * Keep messaging helpful, not punitive — basket is always preserved on block.
 */

export const REQUIRE_GOODS_RECEIPT_TOGGLE_LABEL =
  'Require previous orders to be receipted before placing another order'

export const REQUIRE_GOODS_RECEIPT_TOGGLE_HINT =
  'Prevent users from placing another order with this supplier until previous deliveries have been receipted. This improves stock accuracy, invoice matching and purchasing records.'

export const REQUIRE_GOODS_RECEIPT_TOGGLE_DESCRIPTION =
  'When this is on, the team cannot submit a new order for this supplier until outstanding deliveries have been receipted on Goods Receipting. Existing baskets are kept if an order is blocked.'

export const GOODS_RECEIPT_REQUIRED_CODE = 'GOODS_RECEIPT_REQUIRED'

export const GOODS_RECEIPT_REQUIRED_TITLE = 'Goods Receipt Required'

export const GOODS_RECEIPTING_LEARN_MORE_TITLE = 'What is Goods Receipting?'

export const GOODS_RECEIPTING_LEARN_MORE_BODY = [
  'Goods Receipting confirms what was actually delivered by your supplier.',
  'This helps keep your stock, invoices and purchasing reports accurate.',
  'To receipt an order:',
  '1. Open Purchasing',
  '2. Select Goods Receipting',
  '3. Open the outstanding order',
  '4. Confirm the quantities received',
  '5. Save',
  'Once complete, you can immediately return and place your next order.',
]

/**
 * @param {string} [supplierTitle]
 * @param {string} [backendMessage]
 * @returns {{ headline: string, reason: string, basketNote: string, nextStep: string }}
 */
export function buildGoodsReceiptRequiredCopy(
  supplierTitle = 'this supplier',
  backendMessage = '',
) {
  const title =
    typeof supplierTitle === 'string' && supplierTitle.trim()
      ? supplierTitle.trim()
      : 'this supplier'

  const headline =
    (typeof backendMessage === 'string' && backendMessage.trim()) ||
    `Before you can place another order with ${title}, you need to receipt your previous delivery.`

  return {
    headline,
    reason: `This venue has enabled Require Goods Receipt Before Reordering for ${title} to help keep stock, invoices and reporting accurate.`,
    basketNote: 'Good news: Your current basket has been saved.',
    nextStep:
      'Please receipt your previous order, then return to your basket to submit this order.',
  }
}

/**
 * @param {object} errorData - API error payload (code, message, details fields)
 * @returns {{ supplierTitle: string, message: string, outstandingCount: number }}
 */
export function parseGoodsReceiptRequiredError(errorData = {}) {
  const details =
    errorData.details && typeof errorData.details === 'object'
      ? errorData.details
      : errorData

  const supplierTitle =
    details.supplierTitle || errorData.supplierTitle || 'this supplier'

  const outstandingCount = Number(
    details.outstandingCount ?? details.outstandingPurchaseOrders?.length ?? 0,
  )

  return {
    supplierTitle,
    message: errorData.message || '',
    outstandingCount,
  }
}
